import { render } from "./AuditRiskArticles.vue?vue&type=template&id=cd00186c&scoped=true"
import script from "./AuditRiskArticles.vue?vue&type=script&lang=js"
export * from "./AuditRiskArticles.vue?vue&type=script&lang=js"

import "./AuditRiskArticles.vue?vue&type=style&index=0&id=cd00186c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd00186c"]])

export default __exports__